/* eslint eqeqeq: 0 */
import React, { Component } from "react";
import { Col, Row } from "reactstrap";
import { languageService } from "../../../../Language/language.service";
import { themeService } from "../../../../theme/service/activeTheme.service";
import { MyPlanningTableStyle } from "../../../Dashboard/styles/MyPlanningTableStyle";
import ThisTable from "../../../Common/ThisTable";
import moment from "moment";
import { commonStylesDashboard } from "../../../Dashboard/styles/commonStylesDashboard";
import { UtilFunctions } from "../../../Reports/WorkOrderReport/CommonUtilFunction";

const statusBaseStyle = MyPlanningTableStyle.statusStyle.default;
const reviewStateValue = {
  submit: "Pending Review",
  return: "Returned",
  complete: "Closed",
};

class ExecutionTable extends Component {
  constructor(props) {
    super(props);

    this.columns = [
      {
        id: "mrNumber",
        Header: languageService("MR#"),
        accessor: (row) => {
          const maintenance = row.maintenance;
          if (!maintenance) return "";
          return maintenance.mrNumber || "";
        },
        Cell: ({ value }) => <div style={{ fontSize: "12px" }}>{value}</div>,
        minWidth: 100,
      },
      {
        Header: languageService("Asset Name"),
        id: "AssetName",
        accessor: (row) => {
          const maintenance = row.maintenance;
          if (!maintenance) return "";
          const { issue } = maintenance && maintenance;
          return issue && issue.unit && issue.unit.unitId;
        },
      },

      {
        Header: languageService("Location"),
        id: "location",
        accessor: (row) => {
          return row.lineName;
        },
      },
      {
        Header: languageService("Mile Post"),
        id: "milePosts",
        accessor: (row) => {
          const maintenance = row.maintenance;
          if (!maintenance) return "";
          const { issue } = maintenance;
          const { startMp, endMp } = UtilFunctions.getMPS({}, maintenance);
          let isLinear = issue.startMp && issue.endMp ? true : false;
          const returnValue = isLinear ? `${startMp} - ${endMp}` : startMp;
          return returnValue;
        },
        sortMethod: (a, b) => {
          const getFirstNumber = (str) => {
            const match = str.split(" ");
            let x = match ? parseFloat(match[0]) : Number.POSITIVE_INFINITY;
            if (isNaN(x)) {
              return Number.POSITIVE_INFINITY;
            }
            return x;
          };
          const firstNumberA = getFirstNumber(a);
          const firstNumberB = getFirstNumber(b);
          return firstNumberA - firstNumberB;
        },
      },
      {
        id: "date",
        Header: languageService("Date"),
        accessor: "date",
        Cell: ({ value }) => <div style={{ fontSize: "12px" }}>{value ? moment(value).format("ddd, MMM D, YYYY") : ""}</div>,
        minWidth: 150,
      },
      {
        id: "State",
        Header: languageService("State"),
        accessor: (row) => {
          const maintenance = row.maintenance;
          if (!maintenance) return "";
          let res = "";
          let task = (row.tasks && row.tasks[0]) || [];
          let reviewAction = task && task.maintenance && task.maintenance[0] && task.maintenance[0].reviewAction;
          let endDateTime = task && task.maintenance && task.maintenance[0] && task.maintenance[0].endDateTime;
          if (reviewAction) res = reviewStateValue[reviewAction] || "";
          else if (endDateTime) res = "Complete";
          else if (row.status === "Finished") res = "Checked-In";
          else res = "In Progress";
          // const { status } = row;
          return res;
        },
        Cell: ({ value }) => <div style={{ fontSize: "12px" }}>{value}</div>,
        minWidth: 100,
      },
    ];
  }

  render() {
    const { executionList, pageSize, pagination } = this.props;

    return (
      <Col md="12">
        <Row style={themeService(commonStylesDashboard.planningTableContainerMargin)}>
          <div style={{ width: "100%", boxShadow: "3px 3px 5px #cfcfcf" }}>
            <ThisTable
              tableColumns={this.columns}
              tableData={executionList}
              pageSize={pageSize || 10}
              pagination={pagination !== false}
              minRows={pageSize || 10}
              showFilters={false}
              classNameCustom="fillFullHeight"
              forDashboard={true}
              height="auto"
              fromDashboardToLink="/maintenancebacklog"
            />
          </div>
        </Row>
      </Col>
    );
  }
}

export default ExecutionTable;



// WEBPACK FOOTER //
// ./src/components/NewDashboard/widgets/ExecutionListWidget/ExecutionTable.jsx